export const EvaluationGroupTypes = {
    ALL: "all",
    CHALLENGED: "challenged",
} as const;

export type EvaluationGroupType =
  typeof EvaluationGroupTypes[keyof typeof EvaluationGroupTypes];

export const ASSET_SOLUTION_INDEX=1;